import { Modal, Form } from "antd";
import PlanFormFields, { buildPlanPayload } from "./PlanFormFields";

const CreateSubscriptionPlanModal = ({ visible, loading, metadata, onSubmit, onClose }) => {
    const [form] = Form.useForm();

    const handleFinish = (values) => {
        onSubmit(buildPlanPayload(values));
    };

    const handleAfterClose = () => {
        form.resetFields();
    };

    return (
        <Modal
            title="Create Subscription Plan"
            open={visible}
            onCancel={onClose}
            onOk={() => form.submit()}
            confirmLoading={loading}
            width={800}
            afterClose={handleAfterClose}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <PlanFormFields form={form} metadata={metadata} />
            </Form>
        </Modal>
    );
};

export default CreateSubscriptionPlanModal;
